<script setup lang="ts">
import { OrganismCardPromotionProps } from "./OrganismCardPromotion.props"
import { PromotionProps } from "./Promotion.props"
import { HorizontalProps } from "~/components/Banner/DiscountPromo/Horizontal.props"
import CardPromoPromotion from "~/components/Card/Promo/Promotion.vue"

const props = withDefaults(defineProps<OrganismCardPromotionProps>(), {
  firstBgGrey: true
})

const backgroundRules = computed(() => (props.firstBgGrey ? 0 : 1))
</script>

<template>
  <div class="wrapper_organism-card-promotion">
    <p v-if="title" class="dolphin-bold md:elephant-bold mb-4">
      {{ title }}
    </p>

    <div v-if="cards" class="grid-container md:gap-4">
      <div v-for="(card, index) in cards" class="col-span-4" :key="index">
        <BannerDiscountPromoHorizontal
          v-if="(card as HorizontalProps).cardType"
          v-bind="(card as HorizontalProps)"
          full-height
        />
        <CardPromoPromotion
          v-else
          v-bind="(card as PromotionProps)"
          class="-mx-4 md:mx-0 md:bg-grey-main"
          :class="{ 'bg-grey-main': index % 2 === backgroundRules }"
        />
      </div>
    </div>
  </div>
</template>
